module.exports = __webpack_public_path__ + "791f3af951f216759b3a9cb06af5fe8b.png";